export const DocumentType = ["Resume"];